<template>
  <el-card class="charts-card">
    <el-row :gutter="12" class="chart-row">
      <el-col :span="12">
        <div class="chart-item" ref="monthlyFrequencyChart"></div>
      </el-col>
      <el-col :span="12">
        <div class="chart-item" ref="annualTrendChart"></div>
      </el-col>
    </el-row>
    <el-row :gutter="12" class="chart-row">
      <el-col :span="12">
        <div class="chart-item" ref="coalTypeChart"></div>
      </el-col>
      <el-col :span="12">
        <div class="chart-item" ref="seasonalChart"></div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import * as echarts from 'echarts'
import { custShipFrequency, yearlyShipmentTrend, cargoPreferenceAnalysis, quarterlyShipmentAnalysis } from "../api";


export default {
  name: 'TransportationBehavior',
  props: {
    query: { type: Object, default: () => ({}) }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.initMonthlyFrequencyChart()
      this.initAnnualTrendChart()
      this.initCoalTypeChart()
      this.initSeasonalChart()
    },
    initMonthlyFrequencyChart () {
      const chartDom = this.$refs.monthlyFrequencyChart
      const myChart = echarts.init(chartDom)
      custShipFrequency(this.query).then(({ data: { data } }) => {
        const option = {
          title: { text: '月度发运频次', textStyle: { fontSize: 14, fontWeight: 600 } },
          xAxis: {
            type: 'category',
            data: data.title
          },
          yAxis: { type: 'value' },
          series: [
            {
              data: data.data,
              type: 'bar'
            }
          ]
        }
        myChart.setOption(option)
      })

    },
    initAnnualTrendChart () {
      yearlyShipmentTrend(this.query).then(({ data: { data } }) => {
        const chartDom = this.$refs.annualTrendChart
        const myChart = echarts.init(chartDom)
        const option = {
          title: { text: '年度运输趋势', textStyle: { fontSize: 14, fontWeight: 600 } },
          xAxis: {
            type: 'category',
            data: data.title
          },
          yAxis: { type: 'value' },
          series: [
            {
              data: data.data,
              type: 'line',
              smooth: true
            }
          ]
        }
        myChart.setOption(option)
      })

    },
    initCoalTypeChart () {
      const chartDom = this.$refs.coalTypeChart
      const myChart = echarts.init(chartDom)
      cargoPreferenceAnalysis(this.query).then(({ data: { data } }) => {
        const option = {
          title: { text: '煤种偏好分析', textStyle: { fontSize: 14, fontWeight: 600 } },
          series: [
            {
              name: '常用煤种TOPS',
              type: 'pie',
              radius: '50%',
              data: data,
              label: {
                formatter: '{b}: {c}%'
              }
            }
          ]
        }
        myChart.setOption(option)
      })

    },
    initSeasonalChart () {
      const chartDom = this.$refs.seasonalChart
      const myChart = echarts.init(chartDom)
      quarterlyShipmentAnalysis(this.query).then(({ data: { data } }) => {
        const option = {
          title: { text: '季节特征分析', textStyle: { fontSize: 14, fontWeight: 600 } },
          xAxis: {
            type: 'category',
            data: data.title
          },
          yAxis: { type: 'value' },
          series: [
            {
              data: data.data,
              type: 'bar'
            }
          ]
        }
        myChart.setOption(option)
      })

    }
  }
}
</script>

<style scoped lang="scss">
.charts-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;

  ::v-deep .el-card__body {
    padding: 14px 16px 16px;
  }

  .chart-row + .chart-row {
    margin-top: 12px;
  }

  .chart-item {
    width: 100%;
    height: 280px;
    border: 1px solid #edf2f7;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
  }
}
</style>
